import axios from "axios";

// const BASE_URL = "192.168.26.44/pup/api/api/v11/atom/user/getDetails?key=d42121c70dda5edfgd1df6633fdb36c0&platform=D_A&user_id=1";



export const axiosPrivate = axios.create({
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});